import { render, staticRenderFns } from "./SmsHistory.vue?vue&type=template&id=08b6a38f&scoped=true&"
import script from "./SmsHistory.vue?vue&type=script&lang=js&"
export * from "./SmsHistory.vue?vue&type=script&lang=js&"
import style0 from "./SmsHistory.vue?vue&type=style&index=0&id=08b6a38f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6a38f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b6a38f')) {
      api.createRecord('08b6a38f', component.options)
    } else {
      api.reload('08b6a38f', component.options)
    }
    module.hot.accept("./SmsHistory.vue?vue&type=template&id=08b6a38f&scoped=true&", function () {
      api.rerender('08b6a38f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/SmsHistory.vue"
export default component.exports